import React, {useState, useEffect, useMemo} from "react";
import { Grid, Icon, Checkbox, Popup} from 'semantic-ui-react';
import { InputField, DropDown, DatePicker } from 'KN-EU-Broker-Dashboard-UI';
import { reconTypeVal,actionTypeVal,importEntryLocVal,paymentTypeCodeVal, importerIdTypeData, importerIdValidation } from '../../../constants';
import { epochToDate, getImporterList } from '../../../util/index';
import { useDispatch } from "react-redux";
import { updateHeaderTab } from "../../../slices/headerSlice";
import useUpdateForm from "../../../hooks/useUpdateForm";
import { updateCurrentJob } from "../../../slices/currentJobSlice";

const HeaderTabForm2 = ({formData, lowerEnv, onChange, onBlur, onSelect, paymentOnSelect, importerList}) => {
    const {
      importerCode,
      importerOfRecordNumber,
      notifyPartyNumber,
      suretyCompanyCode,
      importerOfRecordType,
      processingPort,
      paymentDetail: {
        paymentTypeCode,
        statementPrintDate,
        paymentId
      } = {}
    } = formData
    const dispatch = useDispatch();
    const {updateForm} = useUpdateForm();
    const [errors, setErrors] = useState({
      importerOfRecordNumber:[] 
    });

    const importerData = useMemo(() => (
      getImporterList(importerList)
    ), [importerList])

    useEffect(() => {
      if(importerOfRecordType){
        if(!importerIdValidation[importerOfRecordType]?.formatRegex.test(importerOfRecordNumber)){
          setErrors({...errors, importerOfRecordNumber: `Please Match the pattern ${importerIdValidation[importerOfRecordType]?.formatDescription}`})
        }
        else{
          setErrors({...errors, importerOfRecordNumber: ""})
        }
      }
    }, [importerOfRecordNumber, importerOfRecordType])

    return ( 
      <Grid.Row>
        <Grid.Column>
          <DropDown 
          label='Importer Name'
          value={importerCode}
          name="importerCode"
          data={importerData}
          onChange={onSelect}
          isDisabled={true}
          />
        </Grid.Column>
        <Grid.Column>
          <DropDown
            label={'ID Type'}
            name="importerOfRecordType"
            value={importerOfRecordType}
            data={importerIdTypeData}
            isDisabled={lowerEnv[0] === 'prod'}
            onChange={onSelect}
          />
        </Grid.Column>
        <Grid.Column>
          <InputField
            label={`IMPORTER ID ${importerIdValidation[importerOfRecordType] ? `[${importerIdValidation[importerOfRecordType]?.formatDescription}]` : ""}`}
            name="importerOfRecordNumber"
            value={importerOfRecordNumber}
            errors={errors.importerOfRecordNumber}
            onBlur={onBlur}
            isDisabled={lowerEnv[0] === 'prod'}
            onChange={onChange}
          />
        </Grid.Column>
        <Grid.Column>
          <InputField 
          label='Notify Party (4811)#' 
          value={notifyPartyNumber}
          name="notifyPartyNumber"
          onChange={onChange}
          onBlur={onBlur}
          />
        </Grid.Column>
        <Grid.Column>
          <InputField 
          label='Surety Code' 
          value={suretyCompanyCode}
          name="suretyCompanyCode"
          onChange={onChange}
          onBlur={onBlur}
          />
        </Grid.Column>
        <Grid.Column>
          <InputField 
          label='Port' 
          value={processingPort}
          name="processingPort"
          onChange={(e) => {
            dispatch(updateCurrentJob({processingPort: e.target.value}));
            onChange(e);
          }}
          isDisabled={lowerEnv[0] === 'prod'}
          onBlur={onBlur}
          />
        </Grid.Column>
        <Grid.Column>
          <DropDown 
            label='Payment Type Code' 
            data={paymentTypeCodeVal}
            value={paymentTypeCode}
            name="paymentDetail.paymentTypeCode"
            id="paymentTypeCode"
            onChange={(e, data) => paymentOnSelect(e, data, "PAYMENT_UPDATE", {paymentId: paymentId})}
          />
        </Grid.Column>
        <Grid.Column>
          <DatePicker 
            label='Prelim Statement Date'
            name="paymentDetail.statementPrintDate"
            id="statementPrintDate"
            format='MM/DD/YYYY'
            onChange={(e, data) => {
              const value = data.value?.length ? data.value : -999;
              dispatch(updateHeaderTab({name: "paymentDetail.statementPrintDate", value}))
              updateForm({target: {name: "statementPrintDate", value: value}}, "PAYMENT_UPDATE", {paymentId: paymentId});
            }} 
            type='date'
            value={statementPrintDate} 
          />
        </Grid.Column>
      </Grid.Row>
     );
}
 
export default HeaderTabForm2;